(function($) {
  // Default behaviour
  ScrollReveal({
      delay: 100,
      mobile: false,
  });

  // Let the featured image slide in from the bottom
  ScrollReveal().reveal(
    '.carousel, .post-thumbnail--animated',
    {
      delay: 50,
      duration: 1850,
      opacity: 0,
      origin: 'top',
      distance: '20px',
    }
  );

  // Let home sections fade in
  ScrollReveal().reveal(
      '.home-section',
      {
          delay: 1000,
          duration: 1000,
          opacity: 0,
          origin: 'top',
          distance: '20px',
      }
  );
})(jQuery);
